import React, { useCallback, useEffect, useState } from 'react';

import { setOwners } from 'bundles/connect/components/store/actions/owners';
import { connect } from 'react-redux';
import UnlockOwners from './unlock_owners';
import ContactSection from './contact_section';
import AiRelatedCompanies from './ai_related_companies';
import type { Ownerships, OwnershipsResponse } from 'bundles/connect/types';

type Props = {
  insightsPropertyId: string;
  owners?: Ownerships[];
  setOwners: (results: OwnershipsResponse) => void;
  showOnClick: boolean;
};

function UnlockableSection(
  { insightsPropertyId, owners, showOnClick = false, setOwners }: Props
) {
  const [show, setShow] = useState(false);
  const [remainingCredits, setRemainingCredits] = useState(0);

  const handleOwnersTabLoaded = useCallback((event) => {
    if (event.target.dataset.jsOwnersTab) setShow(true);
  }, []);

  useEffect(() => {
    // Purposefully wait for the "owners" tab to be shown so that we don't fetch owners every single time we
    // show a property
    window.addEventListener('show.bs.tab', handleOwnersTabLoaded);

    return () => window.removeEventListener('show.bs.tab', handleOwnersTabLoaded);
  }, []);

  // TODO: Once we convert all the property show pages to react we can change this and remove the event wantching above
  useEffect(() => {
    setShow(showOnClick);
  }, [showOnClick]);

  if (!show) return null;

  const COMMON_PROPS = {
    insightsPropertyId,
    remainingCredits,
    onUnlock: setOwners,
    setRemainingCredits
  };

  return (
    <>
      {owners === null && (
        <UnlockOwners {...COMMON_PROPS} />
      )}
      {owners && (
        <div className="d-flex flex-column gap-6">
          <AiRelatedCompanies />
          <ContactSection show={show} {...COMMON_PROPS} />
        </div>
      )}
    </>
  );
}

const mapStateToProps = ({ offMarketProperty }) => ({ owners: offMarketProperty.owners });
export default connect(mapStateToProps, { setOwners })(UnlockableSection);
